import { AccountInformation } from '../../types/manageAccount.type';
import { Button, IconButton, Stack, Typography } from '@mui/material';
import { EditOutlined } from '@mui/icons-material';
import PinCodeForm from './PincodeForm';
import { SelectArea } from './SelectArea';
import AddressForm from './AddressForm';
import useAddressDetails from './FormHandlerHook';

export default function AddressDetails({
  userDetails,
  setUserDetails,
  isEditing,
  setEditing,
}: {
  userDetails: AccountInformation | null;
  setUserDetails: any;
  isEditing: boolean;
  setEditing: any;
}) {
  const {
    loading,
    step,
    setStep,
    newPincode,
    setNewPincode,
    areas,
    selectedAreaIndex,
    setSelectedAreaIndex,
    updatedDetails,
    setUpdatedDetails,
    handlePincodeSubmit,
    handleAreaSubmit,
    handleSaveClick,
    error,
    setError,
    handleCancel,
  } = useAddressDetails(userDetails, setUserDetails, setEditing);

  return (
    <Stack borderRadius={5}>
      <Stack
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        marginBottom={1}
      >
        <Typography variant="body1" fontWeight={'bold'}>
          {isEditing ? 'Update Address Details' : 'Address Details'}
        </Typography>
        {!isEditing && (
          <IconButton onClick={() => setEditing(true)}>
            <EditOutlined sx={{ fontSize: '20px' }} />
          </IconButton>
        )}
      </Stack>
      <Stack flex={1} p={1.5} gap={2} bgcolor={'#fff'} borderRadius={2}>
        {isEditing && (
          <>
            {step === 0 && (
              <PinCodeForm
                newPincode={newPincode}
                setNewPincode={setNewPincode}
                setEditing={setEditing}
                handlePincodeSubmit={handlePincodeSubmit}
              />
            )}
            {step === 1 && (
              <SelectArea
                areas={areas}
                selectedAreaIndex={selectedAreaIndex}
                setSelectedAreaIndex={setSelectedAreaIndex}
                handleAreaSubmit={handleAreaSubmit}
                setEditing={setEditing}
                setStep={setStep}
              />
            )}
          </>
        )}

        {(!isEditing || step === 2) && (
          <>
            <AddressForm
              isEditing={isEditing}
              updatedDetails={updatedDetails}
              setUpdatedDetails={setUpdatedDetails}
              error={error}
              setError={setError}
            />
            {isEditing && (
              <Stack direction={'row'} justifyContent={'flex-end'} gap={2}>
                <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={handleSaveClick}
                  sx={{ textTransform: 'none' }}
                >
                  Save
                </Button>
              </Stack>
            )}
          </>
        )}
      </Stack>
    </Stack>
  );
}
